import React from 'react';

const HeadshotImg = props => {
  const { imgPath, name, jobTitle } = props;

  return (
    <div>
      <img src={ imgPath } style={ { width: '175px', height:'175px', marginLeft: 'auto', marginRight:'auto', marginBottom: '2rem', display: 'block', borderRadius: '50%', boxShadow: '0 16px 38px -12px rgba(0, 0, 0, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)' } } alt={`${ name } profile`}></img>
      <h3 style={{textAlign: 'center'}}>
        <p>{ name }</p>
      </h3>
      <h4 style={{textAlign: 'center'}}>
        <p>{ jobTitle }</p>
      </h4>
    </div>
  )
}

export default HeadshotImg;


// WEBPACK FOOTER //
// ./src/components/HeadshotImg.js